export const TENANT_MODULES = {
  bi: 'business-intelligence',
  business_intelligence: 'business-intelligence-new',
  chrome_extension: 'chrome-extension',
  contact_directory: 'contact-directory',
  documents: 'documents',
  gonogo: 'go-no-go',
  llm_extractions: 'llm-extractions',
  opportunities: 'opportunities',
  pre_projects: 'pre-projects',
  slip_extraction: 'estimation',
  tenders: 'tenders',
  quotes: 'quotes',
  tender_scoring: 'tender-scoring',
  tasks: 'tasks',
  form_filling: 'form-filling',
};

export const TENANT_MODULES_VALUES = Object.values(TENANT_MODULES);
